/** Validates that a given string is filled with at least one non-whitespace character. */
export function isRequiredStringValid(
  value: string | null | undefined
): value is string {
  return !!value && value.trim().length > 0;
}
